import React from "react";
import NavBar from "../nav-bar/Nav";
import './solutions-page.scss';

export default function Solutions() {
    return(
        <div>
        <NavBar />
          <div className="marketing bg-color-5">
              <div className="container">
                  <div className="row featurette">
                  <div className="col-md-8">
                      <h2 className="featurette-heading color-1">SignetRisk SalesAssist. <span className="color-4">MSP sales prospecting that starts with client insights.</span></h2>
                      <p className="lead" style={{color: 'white'}}>Enhance sales prospecting with quantified risk analysis. Create stronger business conversations with prospects with a focus on exposure and risk management from the ground up. Frame products and services in the context of specific risk scenarios and exposure. 
                      </p>
                      <p className="lead" style={{color: 'grey'}}>
* SignetScore based cyber risk assessment * Customizable cyber risk quantification scenario models * Peer discovery for identification of similar prospects *
                      </p>

                  </div>
                  <div className="col-md-4" style={{textAlign: 'center'}}>
                      <span className="material-icons icon-xl color-1">assured_workload</span>
                  </div>
                  </div>
              </div>
          </div>

          <div className="marketing bg-color-10">
              <div className="container">
                  <div className="row featurette">
                      <div className="col-md-8 order-md-2">
                          <h2 className="featurette-heading color-7"> SignetRisk ClientView. <span className="text-muted"> Client facing enterprise cyber risk quantification platform</span></h2>
                          <p className="lead">
                          Manage client specific enterprise cyber risk platform that presents a comprehensive view of internal and external cyber risk findings and exposure scenario models.  
                          </p>
                          <p className="lead" style={{color: 'grey'}}>
* Clear and consise presentation of exposure and risk scenarios * Aggregation of internal and external cyber risk findings * Configure/manage integrations for AWS/M365/Azure/GCP security findings *
                          </p>
                      </div>
                      <div className="col-md-4 order-md-1" style={{textAlign: 'center'}}>
                          <span className="material-icons icon-xl color-6">troubleshoot</span>
                      </div>
                  </div>
              </div>
          </div>
          <div className="marketing bg-color-8">
              <div className="container">
                  <div className="row featurette">
                      <div className="col-md-8">
                          <h2 className="featurette-heading color-7"> SignetRisk BrokerAssist. <span className="text-muted"> Cyber insurance sales that start with an understanding of client risk exposure and business outcomes.</span></h2>
                          <p className="lead">
                          Discuss coverage and limits in the context of specific risk scenarios and business needs. Continue prospecting by identifying similar companies through peer discovery.
                         </p>
                          <p className="lead" style={{color: 'grey'}}>
* Fast and accurate cyber risk assessment reports * Customizable cyber risk exposure models * Identify follow on opportunities for outreach *
                          </p>
                      </div>
                      <div className="col-md-4 order-md-1" style={{textAlign: 'center'}}>
                          <span className="material-icons icon-xl color-2">multiline_chart</span>
                      </div>
                  </div>
              </div>
          </div>


          <div className="marketing bg-color-5">
              <div className="container">
                  <div className="row featurette">
                  <div className="col-md-8">
                      <h2 className="featurette-heading color-1">SignetRisk UnderwriterView. <span className="color-4"> SignetScore based fast cyber risk assessments that work just as well for SMBs as larger organizations.</span></h2>
                      <p className="lead" style={{color: 'white'}}>
                      Underwrite with confidence with data and analytics that work for all segments of the market.  Create straighforward underwriting workflows based on score thresholds that ensure discpline and quality in your book of business. 
                      </p>
                      <p className="lead" style={{color: 'grey'}}>
* SignetScore based cyber risk assessments * Portfolio risk aggregation data * Access to underlying technical data via APIs *
                      </p>

                  </div>
                  <div className="col-md-4" style={{textAlign: 'center'}}>
                      <span className="material-icons icon-xl color-1">fact_check</span>
                  </div>
                  </div>
              </div>
          </div>


        </div>
    )
}
